import { render } from "./Katameya Clinic Hospital.vue?vue&type=template&id=e4400ee6&scoped=true"
const script = {}

import "./Katameya Clinic Hospital.vue?vue&type=style&index=0&id=e4400ee6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e4400ee6"

export default script